var country_array = ["turkey", "canada", "usa", "united-states", "united-kingdom"];
var headerHeight = $('.site-header-main').outerHeight();
$('.site-mobile-nav').css('top', headerHeight);

$(".ced-desc-right-full").click(function(){
  $(".ced-desc-right").toggleClass("activeFull-desc");
  $(this).toggleClass("toggleText-desc")
});

$(".ced-test-full").click(function(){
  $(this).prev(".ced-test-content").toggleClass("activeFull-test");
  $(this).toggleClass("toggleText-test")
});

$('.usf-facet-value').click(function(){
  //console.log($(this).text());
});

// validations


let button = $("[data-submit]");
let email = $(".ced_email");
let name = $(".ced_name");
let last_name=$('.ced_last_name');
let password = $('.ced_password');
let phone = $(".ced_phone");
let error = $("[data-form-error]");
// let name_error = $(".ced_name_error");
// let last_name_error=$('.ced_last_name_error');
// let password_error = $('.ced_password_error');
// let phone_error = $(".ced_phone_error");

//console.log(email.val())
var current_url=location.href;
if(current_url.includes('login'))
{
  
  //console.log(current_url)
}else{
	//console.log('not login')
    button.attr('disabled', 'disabled');
}
// validate_details(error, 'email');

if(email!=null)
{
  email.on('input blur', function(){
  	validate_details(error, 'email');
  })
}
if(name!=null)
{
  name.on('input blur', function(){
  	validate_details(error,'name');
  })
}
if(last_name!=null)
{
  last_name.on('input blur', function(){
  	validate_details(error, 'last_name');
  })
}
if(phone!=null)
{
  phone.on('input blur', function(){
  	validate_details(error, 'phone');
  })
}
if(password!=null)
{
  password.on('input blur', function(){
  	validate_details(error, 'password');
  })
}

function validate_details(error_span, type){
  
	if(type=="email")
    {
        email=$('.ced_email').val();
    	if(email == '')
        {
         error_span.text('**Email Cannot be Blank')
          error_span.css('display', 'block');
         $('.ced_email').attr('data-status', false);
         button.attr('disabled', 'disabled');
        }
      	else if (!email.match(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/) || email.match(/^[0-9]/))
        {
           error_span.text('**Invalid Email format') 
           error_span.css('display', 'block');
           $('.ced_email').attr('data-status', false);
           button.attr('disabled', 'disabled');
        }
        else{
          error_span.text('')
           error_span.css('display', 'none');
          $('.ced_email').attr('data-status', true);
          check_status();
        }
    }
  	if(type=="name")
    {
      name=$('.ced_name').val();
      if(name == '')
        {
         error_span.text('**Name cannot be blank')
         error_span.css('display', 'block');
         $('.ced_name').attr('data-status', false);
         button.attr('disabled', 'disabled');
        }
      	else if (!name.match(/^[A-Za-z\s\-]+$/))
        {
           if(name.length==1)
               $('.ced_name').val("");
             else{
                var new_name=name.slice(0,-1);
                $('.ced_name').val(new_name);
             }
          setTimeout(function(){
			error_span.text('')
            error_span.css('display', 'none');
            validate_details(error_span, 'name');
          }, 3000)
              error_span.text('**Name cannot contain numbers or special characters')
               error_span.css('display', 'block');
             $('.ced_name').attr('data-status', false);
             button.attr('disabled', 'disabled');
        }
        else if(name.length<3){
          error_span.text('**Name cannot be less than 3 characters')
           error_span.css('display', 'block');
          $('.ced_name').attr('data-status', false);
          button.attr('disabled', 'disabled');
         }
        else{
          error_span.text('')
           error_span.css('display', 'none');
          $('.ced_name').attr('data-status', true);
          check_status();
        }
    }
  	if(type=="last_name")
    {
      last_name=$('.ced_last_name').val();
      if(last_name==''){
          error_span.text('')
           error_span.css('display', 'none');
          $('.ced_last_name').attr('data-status', true);
          check_status();
        }
        else if(!last_name.match(/^[A-Za-z\s\-]+$/))
        {
           if(last_name.length==1)
               $('.ced_last_name').val("");
             else{
                var new_name=last_name.slice(0,-1);
                $('.ced_last_name').val(new_name);
             }
          setTimeout(function(){
			error_span.text('')
             error_span.css('display', 'none');
            validate_details(last_name_error, 'last_name');
          }, 3000)
             error_span.text('**Last name should contain only alphabets')
              error_span.css('display', 'block');
             $('.ced_last_name').attr('data-status', false);
             button.attr('disabled', 'disabled');
        }
        else{
          error_span.text('')
           error_span.css('display', 'none');
          $('.ced_last_name').attr('data-status', true);
          check_status();
        }
    }
  	if(type=="phone")
    {
      phone=$('.ced_phone').val();
      if(phone == '')
        {
         error_span.text('**Phone Number cannot be blank');
         error_span.css('display', 'block');
         $('.ced_phone').attr('data-status', false);
         button.attr('disabled', 'disabled');
        }
        else if(phone.length==1 && phone=='0')
        {
			$('.ced_phone').val("");
            error_span.text('**Phone Number cannot begin with 0') 
             error_span.css('display', 'block');
            $('.ced_phone').attr('data-status', false);
            button.attr('disabled', 'disabled');
        }
        else if(!phone.match(/^[0-9]+$/)){
			if(phone.length==1 && phone!="0" )
               $('.ced_phone').val("");
             else{
                var new_phone=phone.slice(0,-1);
                $('.ced_phone').val(new_phone);
             }
            error_span.text('**Phone number cannot contain alphabets or special characters')
             error_span.css('display', 'block');
            setTimeout(function(){
              error_span.text('')
              error_span.css('display', 'none');
              validate_details(error_span, 'phone');
            }, 3000)
             $('.ced_phone').attr('data-status', false);
             button.attr('disabled', 'disabled');
        }
      	else if (phone.length<10)
        {
           error_span.text('**Phone number cannot be less than 10 digits') 
            error_span.css('display', 'block');
           $('.ced_phone').attr('data-status', false);
           button.attr('disabled', 'disabled');
        }
      	else if(phone.length>12){
              var new_phone=phone.slice(0,-1);
                $('.ced_phone').val(new_phone);
           error_span.text('**Phone number cannot be more than 12 digits')
            error_span.css('display', 'block');
           setTimeout(function(){
              error_span.text('')
               error_span.css('display', 'none');
              validate_details(error_span, 'phone');
            }, 3000)
          $('.ced_phone').attr('data-status', false);
          button.attr('disabled', 'disabled');
         }
        else{
          error_span.text('')
           error_span.css('display', 'none');
          $('.ced_phone').attr('data-status', true);
          check_status();
        }
    }
  	if(type=="password")
    {
    	password=$('.ced_password').val();
    	if(password == '')
        {
         error_span.text('**Password Cannot be Blank')
         error_span.css('display', 'block');
         $('.ced_password').attr('data-status', false);
         button.attr('disabled', 'disabled');
        }
      	else if (password.length<8)
        {
           error_span.text('**Password cannot be less than 8 characters') 
            error_span.css('display', 'block');
           $('.ced_password').attr('data-status', false);
           button.attr('disabled', 'disabled');
        }
        else{
          error_span.text('')
           error_span.css('display', 'none');
          $('.ced_password').attr('data-status', true);
          check_status();
        }
    }
}

function check_status()
{
  var status={name_status:'', last_name_status:'', email_status:'', phone_status:'',password_status:''};
	if($('.ced_name')!=null || $('.ced_name')!=undefined)
    {
       status.name_status=$('.ced_name').attr('data-status');
    }
  	if($('.ced_last_name')!=null || $('.ced_last_name')!=undefined)
    {
       status.last_name_status=$('.ced_last_name').attr('data-status');
    }
  	if($('.ced_email')!=null || $('.ced_email')!=undefined)
    {
       status.email_status=$('.ced_email').attr('data-status');
    }
  	if($('.ced_phone')!=null || $('.ced_phone')!=undefined)
    {
       status.phone_status=$('.ced_phone').attr('data-status');
    }
  	if($('.ced_password')!=null || $('.ced_password')!=undefined)
    {
       status.password_status=$('.ced_password').attr('data-status');
    }
  	var count=0, true_status=0;
  	for(individual_status in status)
    {
      	//console.log('status---'+status[individual_status])
    	if(status[individual_status]!=null || status[individual_status]!=undefined)
        {
        	count+=1;
          	if(status[individual_status]=='true')
              true_status+=1;
        }
    }
  	if(count==true_status)
      button.removeAttr('disabled');
}








/*let error = document.querySelector("[data-form-error]");
let email = document.querySelector("[data-email]");
let name = document.querySelector("[data-firstname]");
let button = document.querySelector("[data-submit]");
let pass = document.querySelector("[data-password]");
let phno = document.querySelector("[data-phone]");
let disable = true;

if(phno!=null)
{
	phno.addEventListener('change', function(){
      validatePhone(this.value);
    });
}

if(button != null){
  buttonDisable(disable);

  button.addEventListener("click", () => {
    validateEmail(email.value);
    nameValidate(name.value);
    if(phno != null){
      validatePhone(phno.value);
    }
  });
}
if(email != null){
  email.addEventListener('change', function(){
    validateEmail(this.value);
  });
}

function buttonDisable(bool) {
    if (bool) {
        button.setAttribute("disabled", true);;
    } else {
        button.removeAttribute("disabled");
    }
}
if(name != null){
  name.addEventListener('change', function(){
    nameValidate(this.value);
  });
}
//name validation
function nameValidate(name) {
  console.log(name)
    let pattern = /^[a-zA-Z\s]*$/;
    if (name.length < 3) {
        Object.assign(error, {
            innerText: "Name must be greater 3 character",
            style: "display: block; color: red"
        });
        disable = true;
        buttonDisable(disable);
    } else if (pattern.test(name)) {
        error.style.display = "none";
        if (email.value.length == 0 || pass.value.length == 0) {
            disable = true;
            buttonDisable(disable);
        } else {
            disable = false;
            buttonDisable(disable);
        }

    } else {
        Object.assign(error, {
            innerText: "Name contains any special characters or numbers!",
            style: "display: block; color: red"
        });
        disable = true;
        buttonDisable(disable);

    }
}

// email validation
function validateEmail(email)
 {
    const url = window.location.href;
    const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,4}))$/;
    if (re.test(email) == false) {
        Object.assign(error, {
            innerText: "Email is invalid!",
            style: "display: block; color: red"
        });
        disable = true;
        buttonDisable(disable);
    } else if (email.startsWith('test')) {
        Object.assign(error, {
            innerText: "Email conatins test word!",
            style: "display: block; color: red"
        });
        disable = true;
        buttonDisable(disable);
    } else if(url.includes("/register")){
        error.style.display = "none";
        if (name.value.length == 0 || pass.value.length == 0) {
            disable = true;
            buttonDisable(disable);
        } else {
            disable = false;
            buttonDisable(disable);
        }
    }
     else{
        error.style.display = "none";
        disable = false;
        buttonDisable(disable);
     }
}

// Phone validation

function validatePhone(inputtxt)
{
  console.log(inputtxt);
  var phoneno = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
  if(inputtxt.match(phoneno))
  {
    error.style.display = "none";
    if (name.value.length == 0 || email.value.length == 0) {
      disable = true;
      buttonDisable(disable);
    } else {
      disable = false;
      buttonDisable(disable);
    }
  }
  else
  {
    Object.assign(error, {
            innerText: "Phone number is invalid!",
            style: "display: block; color: red"
        });
    disable = true;
    buttonDisable(disable);
  }
}*/